import React from "react";
import SetPasswordForm from "../components/auth/SetPasswordForm";

const SetPassword = () => {
  return <SetPasswordForm />;
};

SetPassword.propTypes = {
  // PasswordReset component doesn't require props
};

export default SetPassword;
